<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <FilterRuleTableButton @notice='notice'></FilterRuleTableButton>
        <FilterRuleTable ref='ruleTable'></FilterRuleTable>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import FilterRuleTableButton from '../../components/alarmconfig/filterRule/FilterRuleTableButton';
import FilterRuleTable from '../../components/alarmconfig/filterRule/FilterRuleTable';

export default {
  name: 'FilterRulePage',
  components: {
    BasicLayout,
    FilterRuleTableButton,
    FilterRuleTable
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.filterRule')}`
      }
    };
  },
  methods: {
    notice(type) {
      switch (type) {
        case 'add':
          this.$refs.ruleTable.addFunc();
          break;
        case 'remove':
          this.$refs.ruleTable.removeFunc();
          break;
        case 'edit':
          this.$refs.ruleTable.editFunc();
          break;
        case 'refresh':
          this.$refs.ruleTable.getFilterRuleData();
          break;
        case 'able':
          this.$refs.ruleTable.updateStatusFunc('enable');
          break;
        case 'disable':
          this.$refs.ruleTable.updateStatusFunc('unenable');
          break;
        default:
      }
    }
  }
};
</script>